import React, { useEffect, useState } from "react";
import css from "../css/Refer.module.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

import { BsWhatsapp } from "react-icons/bs";

import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
import CopyToClipboard from "react-copy-to-clipboard";
import { FaTelegramPlane } from "react-icons/fa";
import { FiCopy } from "react-icons/fi";

const Refer = ({ user }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `rkwinzo पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते है।
  दोस्तो को शेयर करने पर उनका आपको लाइफ टाइम 2% कमीशन दिया जाएगा  
  
    100% भरोसेमंद प्लेटफार्म। 24 hours support https://rkwinzo.com/login/${user.referral_code}
  
  Your ReferralCode is - ${user.referral_code}.`;

  return (
    <>
      {/* <Header user={user} /> */}
      <div>
        <div
          className="leftContainer mb_space"
          style={{ minHeight: "100vh", height: "100%" }}
        >
          <section className="refer-modern-container">
            {/* SECTION 1: MAIN HEADING */}
            <div className="section-main-header">
              <h2 className="premium-title">Your Referral Earnings</h2>
              <div className="title-underline"></div>
            </div>

            {/* SECTION 2: STATS CARDS (Earnings & Players) */}
            <div className="refer-stats-row">
              <div className="stat-card glass-green">
                <div className="stat-icon-wrapper">
                  <img
                    src={process.env.PUBLIC_URL + "/Referral gift.gif"}
                    alt="players"
                  />
                </div>
                <div className="stat-info">
                  <h3>{user.referral_user?.length || 0}</h3>
                  <p>Active Players</p>
                </div>
                {/* <div className="stat-badge">Network</div> */}
              </div>

              <div className="stat-card glass-gold">
                <div className="stat-icon-wrapper">
                  <img
                    src="/coin.png"
                    alt="earning"
                    className="pulse-animation"
                  />
                </div>
                <div className="stat-info">
                  <h3>₹ {user.referral_earning}</h3>
                  <p>Total Earning</p>
                </div>
                {/* <div className="stat-badge">LifeTime</div> */}
              </div>
            </div>

            {/* SECTION 3: REFERRAL CODE CARD */}
            <div className="refer-code-card">
              <div className="mini-header">
                <h2 className="premium-title text-white">Referral Code</h2>
              </div>
              <p className="invite-text">
                Invite friends and earn{" "}
                <span className="highlight-green">2% commission</span> on every
                win!
              </p>

              <div className="code-display-area">
                <div className="code-text">{user.referral_code}</div>
                <button className="copy-action-btn" onClick={copyCode}>
                  <FiCopy /> Copy
                </button>
              </div>

              <div className="divider">
                <span>Quick Share</span>
              </div>

              <div className="social-grid">
                {/* WhatsApp */}
                <a
                   href={`whatsapp://send?text=Hi%20Friends%2C%20Play%20rkwinzo%20Ludo%20and%20earn%2010000%20daily.%20Download%20Indian%20App%20rkwinzo%0A%0A%20%20rkwinzo%20%E0%A4%AA%E0%A4%B0%20%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A4%82%E0%A5%A4%0A%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%E0%A4%A8%E0%A5%87%20%E0%A4%AA%E0%A4%B0%20%E0%A4%89%E0%A4%A8%E0%A4%95%E0%A4%BE%20%E0%A4%86%E0%A4%AA%E0%A4%95%E0%A5%8B%20%E0%A4%B2%E0%A4%BE%E0%A4%87%E0%A4%AB%20%E0%A4%9F%E0%A4%BE%E0%A4%87%E0%A4%AE%202%25%20%E0%A4%95%E0%A4%AE%E0%A5%80%E0%A4%B6%E0%A4%A8%20%E0%A4%A6%E0%A4%BF%E0%A4%AF%E0%A4%BE%20%E0%A4%9C%E0%A4%BE%E0%A4%8F%E0%A4%97%E0%A4%BE%20%20%0A%0A%20%20100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B2%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%E0%A5%A4%2024%20hours%20support%20https%3A%2F%2Frkwinzo.com%2Flogin%2F${user.referral_code}%0A%20%20%0A%20%20Your%20ReferralCode%C2%A0is%C2%A0-%C2%A0${user.referral_code}.`}
                  className="social-circle wa"
                  target="_blank"
                  rel="noreferrer"
                >
                  <BsWhatsapp />
                </a>

                {/* Telegram */}
                <a
                  href={`https://telegram.me/share/?url=https://rkwinzo.com/login/${user.referral_code}`}
                  className="social-circle tg"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaTelegramPlane />
                </a>

                {/* Facebook */}
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=https://rkwinzo.com/login/${user.referral_code}`}
                  className="social-circle fb"
                  target="_blank"
                  rel="noreferrer"
                >
                  <AiFillFacebook />
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Refer;
